<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    黄贝岭站<br>
站点介绍<br>
黄贝岭站是5号线东端的终点站，也是2号线和5号线的换乘站，位于北斗路与深南东路交叉口处的东侧的深南东路地下，主体沿深南东路呈东西走向。黄贝岭站东北方为黄贝村；北面为集浩大厦；西北方为冶金大厦；南侧为文华花园。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:04	23:37	2号线	2分35秒	5分45秒<br>
莲塘	06:24	00:02	2号线	2分35秒	5分45秒<br>
赤湾	06:14	23:03	5号线	3分钟	5分25秒<br>
黄贝岭	--	--	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:02	23:37	2号线	4分钟	5分钟<br>
莲塘	06:24	00:02	2号线	4分钟	5分钟<br>
赤湾	06:20	23:03	5号线	4分钟	6分钟<br>
黄贝岭	--	--	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:02	00:27	2号线	4分钟	5分钟<br>
莲塘	06:24	01:02	2号线	4分钟	5分钟<br>
赤湾	06:20	00:03	5号线	4分钟	6分钟<br>
黄贝岭	--	--	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
深南东路北侧（东）、凤凰路、黄贝岭公园、黄贝岭牌坊、黄贝岭村<br><br>
B出入口:<br>
深南东路北侧(西)、深圳市罗湖区人民政府、深圳市罗湖区党群服务中心、深圳市罗湖区信访局<br><br>
C出入口:<br>
深南东路南侧（西）、北斗路、文华社区健康服务中心、深圳市行知职业技术学校<br><br>
D出入口:<br>
深南东路南侧（东）、东部景区假日专线、海富花园、文华花园、丹枫白露<br><br>
E出入口:<br>
集浩大厦<br><br>
F出入口:<br>
清平路、福德花园、冶金大厦<br><br>
G出入口:<br>
新天地名居<br><br>
H出入口:<br>
文华大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 黄贝岭地铁站①<br>
10、M205、E26、M182、M191<br><br>
B出入口:<br>
公交站名： 黄贝岭地铁站②<br>
27、69、85、111、220、223、381、M133、M383、高峰专线32、高快巴士5、N14<br><br>
C出入口:<br>
公交站名： 黄贝岭地铁站④<br>
高峰专线32、10、220、223、M182、M383、N14、高峰专线191<br><br>
C出入口:<br>
公交站名： 黄贝岭地铁站③<br>
27、69、85、111、381、M133、大鹏假日专线4<br><br>
D出入口:<br>
公交站名： 黄贝岭地铁站①<br>
M445、高快巴士13<br><br>
D出入口:<br>
公交站名： 黄贝岭地铁站②<br>
NE26、高快巴士5、高快巴士26、M205、E26、M191、高峰专线290<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


